module.exports = __webpack_public_path__ + "static/capture4-77423513fdcc0378194399660630cd41.png";